/**
 * Company-Aware Notification Query Keys Factory
 * Following cursor rules patterns for consistent cache management
 * Clean Code: Organized key structure with proper typing
 * Company Context: Includes optional companyId for company-aware caching
 */
export const notificationKeys = {
  all: ['notifications'] as const,
  lists: () => [...notificationKeys.all, 'list'] as const,
  list: (userId: string, platform: 'web' | 'mobile', companyId?: string) =>
    [...notificationKeys.lists(), { userId, platform, companyId }] as const,
  counts: () => [...notificationKeys.all, 'count'] as const,
  count: (userId: string, platform: 'web' | 'mobile', companyId?: string) =>
    [...notificationKeys.counts(), { userId, platform, companyId }] as const,
  countsByType: () => [...notificationKeys.all, 'countByType'] as const,
  countByType: (userId: string, platform: 'web' | 'mobile', companyId?: string) =>
    [...notificationKeys.countsByType(), { userId, platform, companyId }] as const,
  details: () => [...notificationKeys.all, 'detail'] as const,
  detail: (id: string) => [...notificationKeys.details(), id] as const,
  userNotifications: (userId: string, platform: 'web' | 'mobile', companyId?: string) =>
    [...notificationKeys.all, 'user', userId, platform, companyId || 'no-company'] as const,
}
